import { useAppData } from "eddev/hooks"
import { useMemo } from "react"
import { BROWSE_MODES, FilmSearchMode, FilmSearchModeDef } from "./useFilmSearch"

type ProgramMode = FilmSearchModeDef & {
  key: FilmSearchMode
}

export function useProgramModes(): Map<FilmSearchMode, ProgramMode> {
  const allowedModes = useAppData((d) => d.sffSettings?.festivalSettings?.enabledBrowseModes ?? []) as FilmSearchMode[]

  return useMemo(() => {
    const modes = new Map<FilmSearchMode, ProgramMode>()
    for (let key of allowedModes) {
      const spec = BROWSE_MODES[key]
      modes.set(key, {
        ...spec,
        key: key as FilmSearchMode,
      })
    }
    return modes
  }, [allowedModes, BROWSE_MODES])
}
